
<div class="ambassador--banner">
  <div class="ambassador--banner-overlay"></div>
  <img [lazyLoad]="service.destinationSpecialistImg" defaultImage="assets/img/blank.webp" errorImage="assets/img/blank.webp" draggable="false" alt="Travel destination banner">
</div>

<div class="ambassador--content">
  
  <div class="ambassador--content-pane">
    <div class="ambassador--content-pane-left">
      
      <img [lazyLoad]="(service.ambassadorHighlightImage$ | async)!" defaultImage="assets/img/blank.webp" errorImage="assets/img/blank.webp" draggable="false" alt="Creator House">
      
      <h3 translate="ambassador.apply-to-creator-house"></h3>
      <h3 translate="ambassador.and-gain-access"></h3>
      <h3 translate="ambassador.and-properties1"></h3>

      <h3 class="info-text" translate="ambassador.apply-to-creator-house-full1"></h3>
    
      <ui-action-button rounded (click)="tourAgentApply()">{{ 'ambassador.apply-to-creator-house-btn' | translate }}</ui-action-button>
  
    </div>
    <div class="ambassador--content-pane-right">

      <iframe [src]="youtubeUrl | safeUrl" frameborder="0" allowfullscreen></iframe>
  
    </div>
  </div>

  <br class="mobile"><br class="web"><br class="web"><br class="web">
  <registration-form socialMediaEvent type="ambassador" [class.disabled]="!(service.authenticated$ | async)" (click)="service.verifyAuthentication()"></registration-form>

</div>
